import { Modal } from 'react-bootstrap'
import AccountAccessCard from '../user-settings/account-access'
import { IUser } from './types'

type AdminAccountAccessModalProps = {
    show: boolean
    account: IUser | null
    onHide: () => void
    onChanged: () => void
}

export default function AdminAccountAccessModal({ show, account, onHide, onChanged }: AdminAccountAccessModalProps) {
    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable dialogClassName="admin-access-modal">
            <Modal.Header closeButton>
                <div>
                    <div className="user-management-eyebrow">Account access</div>
                    <Modal.Title as="h5">{account?.username || 'Account'}</Modal.Title>
                    <div className="text-muted small mt-1">Manage e-mail members, roles and login policy for this account.</div>
                </div>
            </Modal.Header>
            <Modal.Body className="bg-light-subtle p-3 p-md-4">
                {show && account && (
                    <AccountAccessCard
                        key={account.username}
                        basePath={`/user/admin/accounts/${encodeURIComponent(account.username)}/access`}
                        accountName={account.username}
                        onChanged={onChanged}
                    />
                )}
            </Modal.Body>
        </Modal>
    )
}
